import { render } from "./ConfigGuide.vue?vue&type=template&id=2a190e47&scoped=true"
import script from "./ConfigGuide.vue?vue&type=script&lang=js"
export * from "./ConfigGuide.vue?vue&type=script&lang=js"

import "./ConfigGuide.vue?vue&type=style&index=0&id=2a190e47&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a190e47"]])

export default __exports__